import common, { getViewer as exportGetViewer } from './common';
import camera from './camera';
import model, {
  getModel as exportGetModel,
  getSavedModel as exportGetSavedModel,
  getOriginalModel as exportGetOriginalModel,
  setSavedModel as exportSetSavedModel,
} from './model';
import vector from './vector';
import elements, {
  getParentForElement as exportGetParentForElement,
} from './element';
import segmentationTree from './segmentationTree';

export const conversionUtils = Hover.ConversionUtils;

export const pushConcat = (array, n) => {
  Array.prototype.push.apply(array, n);
  return array;
};

// TODO: Remove this for 1.0 - Breaking change
// Consumer apps must import machete-redux/utils, and use that to access these functions
// This is here just to try out the util refactor / reorgnization
export const getModel = exportGetModel;
export const getSavedModel = exportGetSavedModel;
export const getOriginalModel = exportGetOriginalModel;
export const getViewer = exportGetViewer;
export const setSavedModel = exportSetSavedModel;
export const getParentForElement = exportGetParentForElement;

export default {
  conversionUtils,
  pushConcat,
  ...common,
  ...camera,
  ...model,
  ...vector,
  ...elements,
  ...segmentationTree,
};
